<script src="./base.js"></script>

<svelte:window on:keydown={documentKeydown} on:keyup={documentKeyup} on:beforeunload={documentBeforeUnload}/>

<!-- <template src="./base.pug"></template>
<style src="./base.scss"></style> -->